module.exports = __webpack_public_path__ + "static/media/flagIcon.31e8c7c2.svg";